import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const namespaced = true;

const state = {
  features: {},
  featuresAvailable: [],
};

export default {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
